import React from "react";
import PropTypes from "prop-types";
import { colorPathogenicity, formatDates } from "../helpers";
import IconExternalLink from "../../../../../../../assets/images/svg/external-link.svg";
import { getVarsoUrl } from "../../../../../common/helpers/helpers";
import PublicationLinks from "../../../../../components/Publications/components/PublicationLinks";

const InformationTable = ({ item }) => {
  if (item && Object.keys(item || {}).length) {
    const mondoURL = item?.mondo_id?.substring(6);
    return (
      <div className="varsome-inner-container">
        <table className="tw-w-full tw-ml-4">
          <thead>
            <tr>
              <th className="tw-w-1/5 tw-font-semibold tw-mb-0">
                Pathogenicity
              </th>
              <th className="tw-w-1/5 tw-font-semibold tw-mb-0">
                Expert Panel
              </th>
              <th className="tw-w-2/5 tw-font-semibold tw-mb-0">Disease</th>
              <th className="tw-w-1/5 tw-font-semibold tw-mb-0">
                Inheritance Mode
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="tw-w-1/5">
                <h5>
                  {item.pathogenicity
                    ? colorPathogenicity(item.pathogenicity)
                    : "-"}
                </h5>
              </td>
              <td className="tw-w-1/5">
                {item.expert_panel ? (
                  <div>
                    <a href={getVarsoUrl(item.guideline)} target="_blank">
                      {item.expert_panel}{" "}
                      <IconExternalLink className="geneInlineIcon" />
                    </a>
                  </div>
                ) : (
                  "-"
                )}
              </td>
              <td className="tw-w-2/5">
                {item.disease || "-"}
                {item.mondo_id && (
                  <div>
                    {"Link to "}
                    <a
                      href={getVarsoUrl(
                        `https://www.ebi.ac.uk/ols4/ontologies/mondo/classes/http%253A%252F%252Fpurl.obolibrary.org%252Fobo%252FMONDO_${mondoURL}`
                      )}
                      target="_blank"
                    >
                      {item.mondo_id}
                    </a>
                  </div>
                )}
              </td>
              <td className="tw-w-1/5">{item.mode_of_inheritance}</td>
            </tr>
          </tbody>
        </table>
        <table className="tw-w-full tw-ml-4 tw-mt-4">
          <thead>
            <tr>
              <th className="tw-w-1/5" />
              <th className="tw-w-1/5 tw-font-semibold tw-mb-0">
                Published date
              </th>
              <th className="tw-w-3/5 tw-font-semibold tw-mb-0">
                Publications
              </th>
              <th className="tw-w-1/5" />
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="tw-w-1/5" />
              <td className="tw-w-1/5">{formatDates(item.published_date)}</td>
              <td className="tw-w-3/5">
                {item.pub_med_references?.length > 0 ? (
                  <PublicationLinks ids={item.pub_med_references} />
                ) : (
                  "-"
                )}
              </td>
              <td className="tw-w-1/5" />
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
  return null;
};

InformationTable.propTypes = {
  item: PropTypes.shape({
    approval_date: PropTypes.string,
    disease: PropTypes.string,
    evidence_met: PropTypes.arrayOf(PropTypes.string),
    evidence_not_met: PropTypes.arrayOf(PropTypes.string),
    expert_panel: PropTypes.string,
    guideline: PropTypes.string,
    mode_of_inheritance: PropTypes.string,
    mondo_id: PropTypes.string,
    pathogenicity: PropTypes.string,
    pub_med_references: PropTypes.arrayOf(PropTypes.number),
    published_date: PropTypes.string,
    repo_link: PropTypes.string,
    retracted: PropTypes.string,
    summary: PropTypes.string,
    version: PropTypes.string,
  }),
};

InformationTable.defaultProps = {
  item: {},
};

export default InformationTable;
